import { useGetAllOfficesQuery } from 'store/api/offices';
import { useHasPermissions } from 'utils/permissionUtil';

const READ_OFFICES = ['READ.OFFICES'];

/**
 * Whether the firm has more than one active office; with a single one the filter panels drop their office filters.
 * Answers true until the office list says otherwise — while it loads and when it fails. A user without READ.OFFICES
 * gets false: the office filters' option list (`GET /v1/offices/min`) would 403, so the filters are never usable.
 */
export const useHasSeveralActiveOffices = (): boolean => {
    const canReadOffices = useHasPermissions(READ_OFFICES);
    const { data: offices } = useGetAllOfficesQuery(undefined, { skip: !canReadOffices });
    return canReadOffices && (!offices || offices.filter((office) => office.isActive).length > 1);
};
